import classNames from 'classnames';
import * as React from 'react';

export type StepProps = {
  active?: boolean;
  disabled?: boolean;
  title: string;
};

export const Step = ({
  active = false,
  disabled = false,
  title,
}: StepProps) => {
  return (
    <div
      className={classNames('sd-stepper-step', {
        'sd-stepper-step-active': active,
        'sd-stepper-step-disabled': disabled,
      })}
    >
      <div className="sd-stepper-step-circle" />
      <div className="sd-stepper-step-line" />
      {title}
    </div>
  );
};

type StepperChild = React.ReactElement<StepProps> | null;

export type StepperProps = React.HTMLAttributes<HTMLDivElement> & {
  children: StepperChild[] | StepperChild;
  className?: string;
  testId?: string;
};

export const Stepper = ({ children, className, testId }: StepperProps) => (
  <div className={classNames('sd-stepper', className)} data-testid={testId}>
    {children}
  </div>
);
